// react
import React from "react"
import { browserHistory, Link } from "react-router"
// material-ui
import { Card, CardActions, CardHeader, CardText } from "material-ui/Card"
import FlatButton from "material-ui/FlatButton"
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from "material-ui/Table"
// app
import AddRemove from "components/common/buttons/AddRemove"
import Avatar from "components/person/Avatar"


const initialState = {
    selectedRow: false
}


class ProfileTable extends React.Component {
    constructor(props) {
        super()

        this.state = initialState

        this.add = () => browserHistory.push("/profile/new")
        this.remove = this.remove.bind(this)

        this.handleRowSelection = this.handleRowSelection.bind(this)
    }

    remove() {
        if (this.state.selectedRow === false) return
        const profile = this.props.profiles.get(this.state.selectedRow)
        this.props.onRemove(profile.get("id"))
    }

    handleRowSelection(rows) {
        const row = (typeof rows[0] === "number") ? (rows[0]) : false
        this.setState({ selectedRow: row })
    }

    render() {
        const rows = []
        let i = 0

        this.props.profiles.forEach(p => {
            rows.push(
                <TableRow
                    key={ p.get("id") }
                    selected={ this.state.selectedRow === i++ }
                >
                    <TableRowColumn>
                        <Link to={ "/profiles/" + p.get("id") } className="underline">
                            { p.get("displayName") }
                        </Link>
                    </TableRowColumn>
                    <TableRowColumn style={{ textAlign: "right" }}>
                        <Avatar person={ p } size={ 37 }/>
                    </TableRowColumn>
                </TableRow>
            )
        })

        return (
            <Card>
                <CardHeader
                    title="Profiles"
                    style={{ paddingBottom: 0 }}
                />
                <CardText>
                    <Table onRowSelection={ this.handleRowSelection }>
                        <TableHeader displaySelectAll={ false }>
                            <TableRow>
                                <TableHeaderColumn>Name</TableHeaderColumn>
                                <TableHeaderColumn />
                            </TableRow>
                        </TableHeader>
                        <TableBody showRowHover={ true }>
                            { rows }
                        </TableBody>
                    </Table>
                    { this.props.count > rows.length ?
                        <FlatButton
                            label="Show more"
                            style={{
                                color: "#555",
                                width: "100%"
                            }}
                            onTouchTap={ this.props.onShowMore }
                        />
                        : null
                    }
                </CardText>
                <CardActions className="clearfix">
                    <AddRemove
                        onAdd={ this.add }
                        onRemove={ this.remove }
                        labels={{
                            add: "New",
                            remove: "Delete"
                        }}
                        disabled={ this.state.selectedRow === false }
                        className="float-left"
                    />
                </CardActions>
            </Card>
        )
    }
}

export default ProfileTable


/** WEBPACK FOOTER **
 ** ./src/components/profiles/List/profiles-table.js
 **/